import { getAmount } from "../utils/Utils";

export function CountComm({commissions, operatorName, currency}: any) {
  var resultat:any[] = [];

  operatorName.forEach((operator: string) => {
    let countOperator = 0;
    commissions.filter((commission: any) => commission.operator_name === operator).forEach((commission :any) => {
      if ( commission.type === 'REFUND' || commission.type === 'PAYMENT') {
          countOperator += Number(commission.producer_part)
      } else {
        countOperator += ( Number(commission.operator_part) + Number(commission.operator_vat_amount) ) 
      }
      
    });
    resultat.push({operator : operator, value : countOperator})
  });

  return (<div>
    {resultat.map(v => {
      return <p>{v.operator} : <span className={v.value < 0 ? 'vtmn-text-red' :''}>{getAmount(v.value, currency)}</span></p>
    })}
  </div>)
} 